export function Loading({ label = "Загрузка..." }: { label?: string }) {
  return (
    <div className="flex items-center justify-center py-8 text-hint">
      <span>{label}</span>
    </div>
  );
}

export function ErrorState({ error }: { error: unknown }) {
  const msg = error instanceof Error ? error.message : String(error);
  return (
    <div className="rounded-lg bg-bg-secondary p-4 text-destructive">
      <div className="font-semibold">Ошибка</div>
      <div className="text-sm">{msg}</div>
    </div>
  );
}
